<template>
  <div style="min-height: 92vh">
    <v-row>
      <v-col md="8">
        <h3>Horarios</h3>
      </v-col>
      <v-col md="4">
        <ModuleHeader>Departamento</ModuleHeader>
        <selectDepartment></selectDepartment>
      </v-col>
    </v-row>
    <uv-data-table
      :config="config"
      :data="horarios"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Horarios">
      <horariosForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </horariosForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import horariosForm from "./HorarioForm.vue";

export default {
  name: "HorarioCrud",
  components: {
    modal,
    uvDataTable,
    horariosForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      MainDepartamento: "",
      horarios: [],
      editData: {},
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "agregarHorarios",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editHorarios",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteHorarios",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            title: "Fecha Inicio",
            dataName: "HoraInicio",
            text: "Fecha Inicio",
            value: "HoraInicio",
          },
          {
            title: "Fecha Termino",
            dataName: "HoraTermino",
            text: "Fecha Termino",
            value: "HoraTermino",
          },
          {
            title: "Estatus",
            dataName: "Activo",
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              if (row["Activo"]) {
                return '<b style="color:green;">Activo</b>';
              } else {
                return '<b style="color:red;">Inactivo</b>';
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    async getHorarios() {
      this.horarios = [];
      /* obtiene el listado de temporadas activas en el sistema  */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.MainDepartamento + "/Horarios"
        );

      if (!data.exists()) {
        return false;
      }
      this.$pgsHelper.log(data.val());
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        this.horarios.push({ id: element[0], ...element[1] });
      });
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "agregarHorarios") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};

        this.toggleModal(true);
      }
      if (buttonId == "editHorarios") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.horarios,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }
      if (buttonId == "deleteHorarios") {
        this.deleteTemporada(idSelected[0]);
      }
    },
    optButtonClick() {},
    deleteTemporada(id) {
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar el Horario?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-eliminarHorario", datos)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El Horario se elimino correctamente",
              "El Horario se elimino correctamente",
              "success"
            );
            this.getHorarios();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    successData(data) {
      let sendData = {
        Nombre: data.Nombre,
        Activo: data.status,
        HoraInicio: data.horas.inicial.format("HH:mm:ss"),
        HoraTermino: data.horas.final.format("HH:mm:ss"),
      };

      sendData.Departamento = this.MainDepartamento;
      this.$pgsHelper.log(sendData);

      if (data.Id == "") {
        this.createTemporada(sendData);
      } else {
        sendData.Id = data.Id;
        this.editTemporada(sendData);
      }
    },
    createTemporada(datos) {
      this.$swal({
        title: "¿Deseas agregar este nuevo Horario?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-crearHorario", datos)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Horario se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getHorarios();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editTemporada(datos) {
      this.$swal({
        title: "¿Deseas editar la información del horario?",
        text: "Las tarifas con el horario seran ajustadas a los nuevos datos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-editarHorario", datos)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Horario se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getHorarios();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getHorarios();
  },
};
</script>
